import { useEffect } from 'react'

import { instantCardApi } from 'redux/services/instant-card'
import {
  GetInstantCardsParams,
} from 'redux/services/instant-card/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetInstantCardsParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = instantCardApi.useLazyInstantCardStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
